import api from "!../../node_modules/.pnpm/style-loader@2.0.0_webpack@4.46.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/.pnpm/css-loader@5.0.1_webpack@4.46.0/node_modules/css-loader/dist/cjs.js!../../node_modules/.pnpm/vue-loader@15.9.6_babel-core@7.0.0-bridge.0_@babel+core@7.12.10__css-loader@5.0.1_webpa_2f9c74bd8b0234781e6cf928f27b0315/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/sass-loader@10.1.1_sass@1.71.1_webpack@4.46.0/node_modules/sass-loader/dist/cjs.js!../../node_modules/.pnpm/vue-loader@15.9.6_babel-core@7.0.0-bridge.0_@babel+core@7.12.10__css-loader@5.0.1_webpa_2f9c74bd8b0234781e6cf928f27b0315/node_modules/vue-loader/lib/index.js??vue-loader-options!./IconBase.vue?vue&type=style&index=0&id=4d52c418&lang=scss&scoped=true&";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};